export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="max-w-2xl mx-auto text-center">
            <div className="w-16 h-16 rounded-full bg-primary-100 flex items-center justify-center mx-auto mb-6">
              <i className="ri-mail-line text-2xl text-primary-600"></i>
            </div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
              联系我们
            </h2>
            <p className="text-sm text-foreground-500 leading-relaxed mb-8">
              如果您对天美麻花星空影视免费观看有任何建议、合作意向或内容投稿，欢迎通过以下方式与我们取得联系。我们重视每一位影视爱好者的反馈，期待与您共同打造更好的免费观影平台。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <div className="flex items-center gap-2 px-6 py-3 bg-background-50 rounded-lg border border-background-200/70">
                <i className="ri-mail-line text-primary-500 w-4 h-4 flex items-center justify-center"></i>
                <span className="text-sm text-foreground-600">contact@tianmeimahua.example.com</span>
              </div>
              <div className="flex items-center gap-2 px-6 py-3 bg-background-50 rounded-lg border border-background-200/70">
                <i className="ri-message-2-line text-accent-500 w-4 h-4 flex items-center justify-center"></i>
                <span className="text-sm text-foreground-600">在线反馈</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}